import { render } from "./xyList.vue?vue&type=template&id=45c6b4cb"
import script from "./xyList.vue?vue&type=script&lang=js"
export * from "./xyList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__